/* eslint-disable react-hooks/exhaustive-deps */
import { RefObject, useState, useEffect } from "react";

export const useOnScreen = (element: RefObject<HTMLElement>, rootMargin?: '-150px') => {
  const [isIntersecting, setIntersecting] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => setIntersecting(entry.isIntersecting), { rootMargin })
    element.current && observer.observe(element.current)
    return () => {
      observer.disconnect()
    }
  }, [])
  return isIntersecting
}
